'use client'

import { Slot } from "@radix-ui/react-slot";
import React, {
	FC,
	ReactNode,
	createContext,
	forwardRef,
	useContext,
} from "react";

export type PreflightProps = {
	children?: ReactNode;
};

const PreflightContext = createContext({ hasEnabledPreflight: false });

export const PreflightProvider: FC<PreflightProps> = (props) => {
	return (
		<PreflightContext.Provider
			value={{ hasEnabledPreflight: true }}
			{...props}
		/>
	);
};

export const PreflightWrapper = forwardRef<HTMLElement, PreflightProps>(
	(props, ref) => {
		const { hasEnabledPreflight } = usePreflight();
		if (!hasEnabledPreflight) return <>{props.children}</>;

		return <Slot className="mabi-ui-preflight" ref={ref} {...props} />;
	}
);

export const usePreflight = () => {
	const context = useContext(PreflightContext);

	if (context === undefined) {
		return { hasEnabledPreflight: false };
	}

	return context;
};
